import { getBrand, isCanada } from '@tcp/core/src/utils';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';
import { BRAND_NAMES } from '@tcp/core/src/constants/pageTitle.constants';

export const getImageUrl = (item) => {
  const updatedProductImage = item?.productimage?.replace('.mp4', '.webp');
  return `${item.productid}/${updatedProductImage}`;
};

export const getRoutePath = (item, itemBrand) => {
  if (itemBrand && itemBrand?.toLowerCase() !== getBrand()) {
    return `/b/${item?.seo_token}$brand=${itemBrand?.toLowerCase()}`;
  }
  return `/b/${item?.seo_token}`;
};

export const getSeoProps = (currentProduct) => {
  const name = currentProduct?.name;
  if (name) {
    const brand = getBrand();
    const brandTitle = `${BRAND_NAMES[brand]} ${isCanada() ? 'CA' : ''}`;
    const pdpSeoDesc = getDynamicLabelValues('dynamic.browse_d.lbl_pdp_SEO_desc');
    const description = pdpSeoDesc && pdpSeoDesc.replace('$1', `${name}`);
    const title = `${name} | ${brandTitle}`;

    return {
      title,
      description,
    };
  }
  return null;
};
